import styled from "styled-components";

import Help from "components/Help";
import { SUPPORT_EMAIL_ID } from "constants/common";

const StyledPrivacy = styled("div")`
  width: 100%;
  max-width: 48rem;
  margin: auto;
  padding: 1em;
`;

const StyledHeading = styled("h1")`
  font-family: Apercu Bold, system-ui, BlinkMacSystemFont, -apple-system, Roboto,
    sans-serif;
  font-weight: 400;
  line-height: 1.25;
  color: hsl(30, 11%, 9%);
  margin: 0;
  padding: 0;
  font-size: 3.5rem;
  text-align: center;
  padding-top: 6rem;
  padding-bottom: 6rem;
`;

export default function Privacy() {
  return (
    <StyledPrivacy>
      <StyledHeading>Let's talk about your privacy</StyledHeading>
      <h2>Our Policy</h2>
      <p>
        Edify is committed to protecting your privacy. We have prepared this
        Privacy Policy to describe to you our practices regarding the Personal
        Data (as defined below) we collect from users of (a) our websites,
        including edify.fit and (b) our services, including the Edify mobile
        applications (the “Edify Mobile Apps”) and our API.
      </p>
      <h2>Our Privacy Promise</h2>
      <ul>
        <li>We won’t spam your networks.</li>
        <li>You control your contacts.</li>
        <li>We will be open and transparent about how we use your data.</li>
      </ul>
      <h2>Our Services</h2>
      <p>
        The Websites, Edify Mobile Apps, the Edify API, and all services
        provided by Edify via each of the foregoing, now and as they become
        available in the future are referred to collectively, the “Services”).
        As part of the Services, Edify organizes and provides efficient means
        to access and receive updates regarding your contacts that may have been
        previously dispersed over many different Third Party Platforms and to
        better manage your email and your calendar, each of which may have
        entries over various Third Party Platforms. “Third Party Platforms” are
        email and calendar services such as Gmail and Google Calendar and other
        similar platforms, from which you authorize us to import your contacts,
        email, and any additional information. Edify’s Services enable you to
        access, organize and receive updates about those with whom you have
        professional relationships, including publicly available information
        about your professional contacts.
      </p>
      <h2>Information We Collect</h2>
      <p>
        When you interact with us through our Services, we may collect
        personally identifiable data (“Personal Data”) and other information
        from you, as further described below:
      </p>
      <p>
        Personal Data That You Provide: We collect Personal Data from you when
        you voluntarily provide such information, such as when you contact us
        with inquiries, respond to one of our surveys, register for access to
        our Services or use certain of our Services. We collect your name and
        contact information as well as your log-in credentials for each Third
        Party Platform (the “Third Party Login Credentials”) that you provide
        us.
      </p>
      <p>
        By voluntarily providing us with Personal Data, you are consenting to
        our use of it in accordance with this Privacy Policy. If you provide
        Personal Data to us via our Services, you acknowledge and agree that
        such Personal Data may be transferred from your current location to the
        offices and servers of Company and the authorized third party service
        providers.
      </p>
      <h2>Personal Information Collected Automatically:</h2>
      <p>
        We receive and store certain types of usage related information whenever
        you interact with Application. For example, Edify may automatically
        receive and record information regarding your computer’s IP address,
        browser information, Facebook user ID, Facebook Page fan status, and
        URLs accessed. Such information may be shared in aggregate
        (non-personally identifiable) form with our partners
      </p>
      <h2>Other Information</h2>
      <p>
        Non-Identifiable Data: When you interact with us through our Services,
        we receive and store certain personally non-identifiable information.
        Such information, which is collected passively using various
        technologies, cannot presently be used to specifically identify you. We
        may store such information ourselves or such information may be included
        in databases owned and maintained by our affiliates, agents or third
        party service providers. We may use such information and pool it with
        other information to track, for example, the total number of visitors to
        our Services, the number of visitors to each page of our web sites, the
        number of individuals who use certain features of our Services, and the
        domain names of our visitors’ Internet service providers.
      </p>
      <p>
        In operating this Services, we may use cookies. Our cookies help provide
        additional functionality our Services and help us analyze the use of our
        Services. On most web browsers, you will find a “help” section on the
        toolbar. Please refer to this section for information on how to receive
        notification when you are receiving a new cookie and how to turn cookies
        off. We recommend that you leave cookies turned on because they allow
        you to take advantage of some of the features of our Services.
      </p>
      <p>
        Our Services may use third party services, including, without
        limitation, Google Analytics, a web analytics service provided by
        Google, Inc. (“Google”) that uses cookies to help us analyze how users
        use our Services. The information generated by the cookie about your use
        of our Services (including your IP address) will be transmitted to and
        stored by Google on our other third party service providers. Google and
        our other third party service providers use this information for the
        purpose of evaluating your use of the Services, compiling reports on
        website activity for website operators and providing other services
        relating to website activity and internet usage. Our third party service
        providers may also transfer this information to third parties where
        required to do so by law, or where such third parties process the
        information on their behalf[GP1] .
      </p>
      <p>
        Aggregated Personal Data: In an ongoing effort to better understand and
        serve the users of our Services, we sometimes conduct research on our
        customer demographics, interests and behavior based on the Personal Data
        and other information provided to us. This research may be compiled and
        analyzed on an aggregate basis, and we may share this aggregate data
        with our affiliates, agents and business partners. This aggregate
        information does not identify you personally. We may also disclose
        aggregated user statistics in order to describe our Services to current
        and prospective business partners, and to other third parties for other
        lawful purposes.
      </p>
      <h2>Use of Your Personal Data and Other Information</h2>
      <p>
        We use the Personal Data you provide in a manner that is consistent with
        this Privacy Policy. If you provide Personal Data for a certain reason,
        we may use the Personal Data in connection with the reason for which it
        was provided.. For instance, if you add notes to a contact, we will use
        the information you provide to give you more information on that
        contact. Also, if you provide Personal Data in order to obtain access to
        our Services, we will use your Personal Data to provide you with access
        to such services and to monitor your use of such services. Any Third
        Party Login Credentials will be used to provide you third party data in
        our services and to monitor your interaction behavior to improve our
        services. Edify and its subsidiaries and affiliates (the “Edify
        Related Companies”) may also use your Personal Data and other personally
        non-identifiable information collected through the use of our Services
        to help us improve the content and functionality of our Services to
        better understand our users and to improve our Services. The Edify
        Related Companies may use this information to contact you in the future
        to tell you about services we believe will be of interest to you. If we
        do so, each communication we send you will contain instructions
        permitting you to “opt-out” of receiving future communications. In
        addition, if at any time you wish not to receive any future
        communications or you wish to have your name deleted from our mailing
        lists, please contact us as indicated below.
      </p>
      <h2>Our Disclosure of Your Personal Data and Other Information:</h2>
      <p>
        Edify is not in the business of selling your Personal Data. We consider
        this information to be a vital part of our relationship with you. There
        are, however, certain circumstances in which we may share your Personal
        Data with certain third parties without further notice to you, as set
        forth below:
      </p>
      <p>
        Business Transfers: As we develop our business, we might sell or buy
        businesses or assets. In the event of a corporate sale, merger,
        reorganization, dissolution or similar event, Personal Data may be part
        of the transferred assets.
      </p>
      <p>
        Related Companies: We may also share your Personal Data with the Edify
        Related Companies for purposes consistent with this Privacy Policy.
      </p>
      <p>
        Agents, Consultants and Related Third Parties: Edify sometimes engages
        other companies to perform certain business-related functions. Examples
        of such functions include mailing information, maintaining databases and
        processing payments. When we engage another company to perform a
        function of this nature, we only provide them with the information that
        they need to perform their specific function.
      </p>
      <p>
        Legal Requirements: Edify may disclose your Personal Data if required
        to do so by law or in the good faith belief that such action is
        necessary to (i) comply with a legal obligation, (ii) protect and defend
        the rights or property of Edify, our users or other third parties,
        (iii) act in urgent circumstances to protect the personal safety of
        users of our Services, the public and/or any third party, or (iv)
        protect against legal liability.
      </p>
      <h2>Your Choices:</h2>
      <p>
        You have the choice to determine which, if any, Third Party Login
        Credentials you elect to supply to us. You also have the choice to
        opt-out of receiving email marketing communications from us.
      </p>
      <ul>
        <li>
          PII is any PHR Data that connects to you as an individual such as
          names, health conditions, and other identifiers. Any additional PHR
          data that is PII will fall under this scope
        </li>
        <li>
          NPII is PHR Data that is 1) grouped so it does not connect to you as
          an individual and 2) has names and other identifiers removed or
          altered.
        </li>
      </ul>
      <p>
        Edify WILL NOT release PII or non PII to any person, company or other
        entity for any reason, including but not limited to: <br />
      </p>
      <ul>
        <li>Marketing and Advertising</li>
        <li>Medical and pharmaceutical research</li>
        <li>Reporting about our company and or customer activity</li>
        <li>Your insurer and employer</li>
        <li>
          We may disclose your personal information to third parties should it
          be required to do so by law or subpoena or if we believe that such
          action is necessary to (a) conform to the law, comply with legal
          process served on us or our affiliates, or investigate, prevent, or
          take action regarding suspected or actual illegal activities; (b) to
          enforce our Terms of Use, take precautions against liability, to
          investigate and defend ourselves against any third-party claims or
          allegations, to assist government enforcement agencies, or to protect
          the security or integrity of our site; and (c) to exercise or protect
          the rights, property, or personal safety of Company, or to otherwise
          act in the best interests of our users or others.
        </li>
      </ul>
      <p>
        Your Personal Data is only collected by us from your direct use with the
        Edify, and only if you granted permission. <br />
        If you close or transfer your profile with us, we no longer collect any
        PHR data
      </p>
      <h2>Children:</h2>
      <p>
        The Services are not designed for or intended for use by children and
        Edify does not knowingly collect Personal Data from children under the
        age of 16. If you are under the age of 13, please do not submit any
        Personal Data through our Services.. If you have reason to believe that
        a child under the age of 13 has provided Personal Data to Edify through
        this Services, please contact us, <br />
        and we will endeavor to delete that information from our databases.
      </p>
      <h2>Links to Other Web Sites:</h2>
      <p>
        This Privacy Policy applies only to our Services. Our Services may
        contain links to other web sites not operated or controlled by us (the
        “Third Party Sites”). The policies and procedures we described here do
        not apply to the Third Party Sites. The links from our Services do not
        imply that we endorse or have reviewed the Third Party Sites. We suggest
        contacting those sites directly for information on their privacy
        policies.
      </p>
      <h2>Social Media:</h2>
      <p>
        Through our Services, you can choose to access certain social media
        websites and services that are owned and/or controlled by third parties
        (such websites and services, collectively, the “Social Media Services”).
        When you elect to access and use the Social Media Services, you will be
        sharing your information (which will include personal information if you
        elect to share such information) with those Social Media Services. As
        with other Third Party Sites, the information that you share with the
        Social Media Services will be governed by the privacy policies and terms
        of service of the providers of such Social Media Services and not by the
        policies and procedures we describe here. You may also be able to modify
        your privacy settings with these Social Media Services to, for example,
        control what information the Social Media Services disclose to other
        entities, including Company. When you add Social Media Service accounts
        to the Company Services or log into our Services using your Social Media
        Services account, we will collect relevant information necessary to
        enable our Services to access that Social Media Service, however you
        will provide your login information, like your password, directly to
        such Social Media Service (and not to Company). As part of such
        integration, the Social Media Service will provide Company with access
        to certain information that you have provided to such Social Media
        Service, and we will use, store and disclose such information in
        accordance with this Privacy Policy and, if and to the extent
        applicable, the policies of such Social Media Services. However, please
        remember that the manner in which Social Media Services use, store and
        disclose your information is governed by the policies of the applicable
        Social Media Services provider, and, as a result, Company shall not have
        any liability or responsibility for the privacy practices or other
        actions of Social Media Services that may be enabled within and/or
        otherwise accessible through our Services.
      </p>
      <h2>Security:</h2>
      <p>
        Company takes reasonable steps to protect the Personal Data provided via
        our Services from loss, misuse, and unauthorized access, disclosure,
        alteration, or destruction. However, no Internet or e-mail transmission
        is ever fully secure or error free. In particular, e-mail sent to or
        from our Services may not be secure. Therefore, you should take special
        care in deciding what information you send to us via e-mail. Please keep
        this in mind when disclosing any Personal Data to Edify via the
        Internet.
      </p>
      <h2>Other Terms and Conditions:</h2>
      <p>
        Your access to and use of our Services is subject to the Terms of Use.
      </p>
      <h2>Changes to Our Privacy Policy:</h2>
      <p>
        Our Services and our business may change from time to time. As a result,
        at times it may be necessary for Edify to make changes to this Privacy
        Policy. Edify reserves the right to update or modify this Privacy
        Policy at any time and from time to time without prior notice. Please
        review this policy periodically, and especially before you provide any
        Personal Data. This Privacy Policy was last updated on the date
        indicated above. Your continued use of our Services after any changes or
        revisions to this Privacy Policy shall indicate your agreement with the
        terms of such revised Privacy Policy.
      </p>
      <h2>Access to Information; Contacting Edify:</h2>
      <p>
        To keep your Personal Data accurate, current, and complete, please
        contact us as specified below. We will take reasonable steps to update
        or correct Personal Data in our possession that you have previously
        submitted via our Services.
      </p>
      <p>
        Please also feel free to contact us if you have any questions about
        Edify’s Privacy Policy or the information practices of our Services.
      </p>
      <p>
        You may contact us as follows: <Help text={SUPPORT_EMAIL_ID} />
      </p>
      <p>
        <strong>
          <br />
        </strong>
      </p>
    </StyledPrivacy>
  );
}
